// extracted by mini-css-extract-plugin
export var alt = "ParagraphTeaserList-module--alt--6be21";
export var desktopOnly = "ParagraphTeaserList-module--desktopOnly--64b98";
export var main = "ParagraphTeaserList-module--main--c4f04";
export var mobileOnly = "ParagraphTeaserList-module--mobileOnly--d1eca";
export var styledContainer = "ParagraphTeaserList-module--styledContainer--79f6f";
export var textLeft = "ParagraphTeaserList-module--textLeft--b1f72";
export var visuallyHidden = "ParagraphTeaserList-module--visuallyHidden--c015a";